module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/32-6b702a290d7e79054447b4c02be46961.jpg";